import React, { Component } from 'react';
import { object, oneOf, bool, string } from 'prop-types';
import { Box, Drawer } from '@mui/material';
import { I18n } from 'utils/i18n';
import connector from './connector';
import CloseButton from '../CloseButton';
import MediaTabs from './MediaTabs';
import DrawerTitle from './DrawerTitle';

class MediaDrawer extends Component {
  handleClose = () => {
    const { actions } = this.props;
    actions.mediaDrawer.close();
  };

  render() {
    const { type, isOpen, channelName } = this.props;

    if (!isOpen) return null;

    return (
      <Drawer anchor="right" open={isOpen} onClose={this.handleClose}>
        <Box
          sx={{
            display: 'flex',
            width: { xs: '100%', md: 1000 },
            height: '100%',
          }}
        >
          <Box sx={{ paddingTop: '20px', paddingLeft: '20px' }}>
            <CloseButton onClick={this.handleClose} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              padding: '20px 30px 0 40px',
            }}
          >
            <DrawerTitle>{`${channelName} ${I18n.t('files')}`}</DrawerTitle>
            <MediaTabs tab={type} />
          </Box>
        </Box>
      </Drawer>
    );
  }
}

MediaDrawer.propTypes = {
  actions: object.isRequired,
  isOpen: bool.isRequired,
  type: oneOf(['media', 'doc', 'link']).isRequired,
  channelName: string,
};
MediaDrawer.defaultProps = {
  channelName: null,
};

export default connector(MediaDrawer);
